// In quicklinks.jsx
export const QuickLinks = () => {
  // component code
};
